/* eslint-disable max-len */
import React, { useState, useEffect, useRef, useCallback } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Text from './../Components/Text'
import Button from './../Components/Button'
import { colors } from '../Themes'
import { Arrow, Arrow1, Arrow2, Arrow3, Circles, DoctorAvatar, LogoDP, Robot, Robot2 } from '../Themes/Images'
import useElementOnScreen from '../Utils/useIntersectionObserver'
import HeroHome from '../Components/HeroHome/HeroHome'
import Integrations from '../Components/IntegrationsSection/IntegrationsSection'
import CardHolder from '../Components/CardHorizontal/CardHorizontal'
import InfiniteCarousel from '../Components/InfiniteCarousel/InfiniteCarousel'
import { WHAT_DP_CAN_DO } from '../Utils/HomePageData'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'

function calcDynamicHeight(ref) {
  const vw = window.innerWidth
  const vh = window.innerHeight
  const objectWidth = ref.scrollWidth
  // 150 is the padding (in pixels) desired on the right side of the .cards container. This can be set to whatever your styles dictate
  return objectWidth - vw + vh + 150
}

const isDarkMode =
  window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches

const getStarted = (url) => {
  window.open(url, '_blank', 'noopener,noreferrer')
}


const CASE_STUDIES = [
  {
    id: 1, title: 'How data analytics helped the Foot Company grow their Clinic Group', url: 'https://dyl2njn37ytxk.cloudfront.net/website-sep9/resources2/How-data-analytics-helped-the-Foot-Company-grow-its-clinics-group-3%201.png',
    description: 'The Foot Company, a podiatry clinic group shares how they used Dataplayer analytics and reports to streamline their operations.',
    link: 'https://blog.dataplayer.io/how-data-analytics-helped-the-foot-company-grow-their-clinic-group/'
  },
  {
    id: 2, title: 'Empowered by data: Human Nature Adventure Therapy', url: 'https://dyl2njn37ytxk.cloudfront.net/websiteSEO/svg/Empowered%20420%2014.svg',
    description: 'One of our users, Human Nature, shares how they use data to grow their organisation.',
    link: 'https://blog.dataplayer.io/empowered-by-data-human-nature-adventure-therapy/'
  }
]

const logosCarouselStyles = makeStyles((theme) => ({
  wrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    gap: 46,
    paddingBlock: 70,
    maxWidth: 1100,
    marginInline: 'auto',
    [theme.breakpoints.up(1921)]: {
      maxWidth: 1300,
    },
    [theme.breakpoints.down(1440)]: {
      maxWidth: 1000,
    },
    [theme.breakpoints.down(1100)]: {
      maxWidth: 900,
    },
    [theme.breakpoints.down(960)]: {
      maxWidth: 700,
    },
    [theme.breakpoints.down(760)]: {
      maxWidth: '100%',
      paddingInline: 16,
      paddingBlock: 40,
    },
  },
  gradientText: {
    display: 'flex',
    background: 'linear-gradient(175deg, #90205D 12.96%, rgba(238, 67, 82, 0.97) 63.2%)',
    backgroundClip: 'text',
    '-webkit-background-clip': 'text',
    '-webkit-text-fill-color': 'transparent',
  },
}))

const LogosCarousel = () => {
  const classes = logosCarouselStyles()
  const ref = useRef()
  const onScreen = useElementOnScreen(ref)

  return (
    <section ref={ref} className={classes.wrapper}
      style={{
        opacity: onScreen ? 1 : 0,
        translate: onScreen ? 'none' : '0 50px',
        transition: '1s ease-in-out',
      }}>
      <Text style={{ display: 'flex', flexWrap: 'wrap' }} size='h4'>Trusted by Worldwide&nbsp; <Text size='h4' className={classes.gradientText} weight='bold'> Leading&nbsp;</Text>  Clinics</Text>
      <InfiniteCarousel />
    </section>
  )
}

const whatDataplayerOffersStyles = makeStyles((theme) => ({
  mainWrapper: {
    display: 'flex',
    background: colors.white,
    width: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    // gap: 65,
    paddingBlock: 70,
    marginInline: 'auto',
    maxWidth: 1100,
    flexDirection: 'column',
    [theme.breakpoints.up(1921)]: {
      maxWidth: 1300,
      justifyContent: 'space-between',
    },
    [theme.breakpoints.down(1440)]: {
      maxWidth: 1000,
      justifyContent: 'space-between',
    },
    [theme.breakpoints.down(1100)]: {
      maxWidth: 900,
      justifyContent: 'space-between',
    },
    [theme.breakpoints.down(960)]: {
      maxWidth: 700,
      justifyContent: 'space-between',
    },
    [theme.breakpoints.down(760)]: {
      maxWidth: '100%',
      flexDirection: 'column',
      // gap: 20,
      paddingInline: 16,
      paddingBlock: 40,
    },
  },
  itemContainer: {
    display: 'flex',
    flexDirection: 'column',
    // borderTop: `2px solid ${colors.primary}`,
    width: '50%',
  },
  textContainer: {
    display: 'flex',
    flexDirection: 'column',
    paddingInline: 30,
    paddingBlock: 34,
    border: `1px dashed ${colors.disabled}`,
    alignItems: 'start',
    justifyContent: 'space-between',
    minHeight: 447,
    width: '50%'
  },
  integrationText: {
    width: 'fit-content',
    border: '1px solid rgba(238, 67, 82, 0.97)',
    borderRadius: 24,
    paddingInline: 29,
    paddingBlock: 7,
    marginBottom: 16
  },
  colorText: {
    background: 'linear-gradient(90deg, #90205D 0%, rgba(238, 67, 82, 0.97) 100%)',
    backgroundClip: 'text',
    '-webkit-background-clip': 'text',
    '-webkit-text-fill-color': 'transparent',
  },
  mainTitle: {
    marginBottom: 60,
    [theme.breakpoints.down(960)]: {
      marginBottom: 16,
    },
  },
  gradientText: {
    display: 'inline-block',
    background: 'linear-gradient(175deg, #90205D 12.96%, rgba(238, 67, 82, 0.97) 63.2%)',
    backgroundClip: 'text',
    '-webkit-background-clip': 'text',
    '-webkit-text-fill-color': 'transparent',
  },
  contentHolder: {
    gap: 80,
    display: 'flex',
    width: '100%',
    alignItems: 'center',
    justifyContent: 'space-between',
    [theme.breakpoints.down(1440)]: {
      gap: 30
    },
    [theme.breakpoints.down(960)]: {
      marginTop: 48
    },
  },
  firstPart: {
    display: 'flex',
    flexBasis: '55%',
    gap: 100,
    [theme.breakpoints.down(960)]: {
      flexBasis: '100%',
      gap: 100,
    },
  },
  secondPart: {
    display: 'flex',
    flexBasis: '45%',
    flexDirection: 'column',
    gap: 16,
    [theme.breakpoints.down(960)]: {
      flexBasis: '100%',
      alignItems: 'center'
    },
  },
  imageHolder: {
    position: 'relative'
  },
  avatar: {
    // [theme.breakpoints.down(960)]: {
    //   maxWidth: '70%'
    // },
  },
  logo: {
    position: 'absolute',
    top: '4%',
    left: -38,

  },
  arrow1: {
    position: 'absolute',
    top: '4%',
    left: 25
  },
  arrow2: {
    position: 'absolute',
    top: '10%',
    left: 25
  },
  arrow3: {
    position: 'absolute',
    top: '17%',
    left: 25
  },
  list: {
    display: 'flex',
    flexDirection: 'column',
    gap: 32,
    justifyContent: 'flex-end',
    [theme.breakpoints.down(625)]: {
      width: '100%'
    },
  },
  item: {
    width: 341,
    border: `1px solid ${colors.primary}`,
    borderRadius: 24,
    paddingInline: 16,
    paddingBlock: 5,
    cursor: 'pointer',
    justifyContent: 'center',
    display: 'flex',
    [theme.breakpoints.down(625)]: {
      width: '100%',
    },
    transition: '0.5s ease-in-out',
    '&:hover': {
      translate: '0 -5px',
      background: 'linear-gradient(90deg, #EF4352 0%, #90205D 100%)',
      backgroundClip: 'text',
      '-webkit-background-clip': 'text',
      '-webkit-text-fill-color': 'transparent',
      border: '1px solid rgba(238, 67, 82, 0.97)',
    },
    '&:active': {
      translate: '0 2px',
      background: 'linear-gradient(90deg, #90205D 0%, #EF4352 100%)',
      backgroundClip: 'text',
      '-webkit-background-clip': 'text',
      '-webkit-text-fill-color': 'transparent',

      // Change pseudo-element color effect on click
      '&::before': {
        background: 'linear-gradient(90deg, #90205D 0%, #EF4352 100%)',
      }
    }
  },
  activeText: {
    display: 'flex',
    background: 'linear-gradient(90deg, #EF4352 0%, #90205D 100%)',
    backgroundClip: 'text',
    '-webkit-background-clip': 'text',
    '-webkit-text-fill-color': 'transparent',

  },
}))

const ListItem = ({ item, active, onClick, goToArticle }) => {
  const classes = whatDataplayerOffersStyles()

  return (
    <article className={classes.item} onClick={goToArticle}>
      <Text className={active ? classes.activeText : null} size='body'><a style={{ color: colors.primary, textDecoration: 'none' }} href={item.href}>{item.text}</a></Text>
    </article>
  )
}
const SCREEN_CONTENT = {
  NewHome: 'NewHome',
  Article: 'Article'
}

export const WhatDataplayerOffers = ({ isMobile, isMobileSmall, setSuccess, setSelectedArticleId }) => {
  const classes = whatDataplayerOffersStyles()
  const ref = useRef()
  const onScreen = useElementOnScreen(ref)
  const [show, setShow] = useState(0)
  const [isHoveredItem, setIsHoveredItem] = useState(1)

  const handleShow = useCallback((id) => {
    setShow(id)
  }, [])

  const handleHover = useCallback((id) => {
    setIsHoveredItem(id)
  }, [])
  const history = useHistory()
  const handleLinkClick = (e, itemId) => {
    e.preventDefault()
    history.push(`/article/${itemId}`)
  }

  return (
    <section ref={ref} className={classes.mainWrapper} style={{
      opacity: onScreen ? 1 : 0,
      translate: onScreen ? 'none' : '0 50px',
      transition: '1s ease-in-out',
    }}>
      <div className={classes.mainTitle}>
        <Text weight='medium' size='h2'>What You Can Achieve with&nbsp;
          <Text className={classes.gradientText} size='h2' weight='medium'>Dataplayer&nbsp;</Text>
        </Text>
      </div>
      {isMobile &&
        <div className={classes.secondPart}>
          <Text size='body'>Simplify practice management with powerful tools for tracking, analysing, and visualising data.</Text>
          <Text size='body'>Our features support goal setting, performance monitoring, and advanced analytics.</Text>
        </div>
      }
      <div className={classes.contentHolder}>
        <div className={classes.firstPart}>
          {!isMobileSmall &&
            <div style={{ display: 'flex' }}>
              <DoctorAvatar className={classes.avatar} />
              <div className={classes.imageHolder}>
                <LogoDP className={classes.logo} />
                <Arrow1 className={classes.arrow1} />
                <Arrow2 className={classes.arrow2} />
                <Arrow3 className={classes.arrow3} />
              </div>
            </div>
          }

          <div className={classes.list}>
            {WHAT_DP_CAN_DO.slice(0, 5).map((item) => {
              const isActive = item.id === show
              const isHovered = item.id === isHoveredItem
              return (
                <a
                  style={{ textDecoration: 'none' }}
                  key={item.id}
                  href={`/article/${item.id}`}
                  aria-label="article"
                  onClick={(e) => handleLinkClick(e, item.id)}
                >
                  <ListItem
                    key={item.id}
                    item={item}
                    active={isActive}
                    onMouseEnter={() => handleHover(item.id)}
                    onMouseLeave={() => handleHover(null)}
                    onClick={() => handleShow(item.id)}
                    isActive={isActive}
                    isHovered={isHovered}
                  />
                </a>
              )
            })}
          </div>
        </div>
        {!isMobile &&
          <div className={classes.secondPart}>
            <Text size='body'>Simplify practice management with powerful tools for tracking, analysing, and visualising data.</Text>
            <Text size='body'>Our features support goal setting, performance monitoring, and advanced analytics.</Text>
          </div>
        }

      </div>

    </section>
  )
}

const horizontalScrollerStyles = makeStyles((theme) => ({
  mainWrapper: {
    display: 'flex',
    background: '#F8F8F8',
    width: '100%',
    alignItems: 'center',
    justifyContent: 'center',
  },
  leftContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
    minWidth: 800,
    [theme.breakpoints.down(1440)]: {
      minWidth: 500,
    },
    [theme.breakpoints.down(760)]: {
      minWidth: 300,
    },
    // [theme.breakpoints.down(1200)]: {
    //   minWidth: 600,
    // },
  },
  integrationText: {
    width: 'fit-content',
    border: '1px solid rgba(238, 67, 82, 0.97)',
    borderRadius: 24,
    paddingInline: 29,
    paddingBlock: 7,
    marginBottom: 16
  },
  colorText: {
    // background: 'linear-gradient(90deg, #90205D 0%, rgba(238, 67, 82, 0.97) 100%)',
    // backgroundClip: 'text', 
    // '-webkit-background-clip': 'text',
    // '-webkit-text-fill-color': 'transparent',
  },
  assistant: {
    maxWidth: '80%',
    marginBottom: 10,
    [theme.breakpoints.down(1440)]: {
      maxWidth: '65%',
    },
    [theme.breakpoints.down(1280)]: {
      maxWidth: '50%',
    },
    [theme.breakpoints.down(760)]: {
      maxWidth: '60%',
    },
  },
  description: {
    maxWidth: '35%',
    marginBottom: 50,
    [theme.breakpoints.down(1440)]: {
      maxWidth: '55%',
    },
    [theme.breakpoints.down(1280)]: {
      maxWidth: '45%',
    },
    [theme.breakpoints.down(760)]: {
      maxWidth: '55%',
    },
  },
  learnMore: {
    maxWidth: 240
  },
  cardHolder: {
    display: 'flex',
    gap: 46,
    /* Adjust width based on content */
    width: '30%',
  }
}))

const HorizontalScroller = () => {
  const classes = horizontalScrollerStyles()

  const history = useHistory()

  const spaceHolder = document.querySelector('.space-holder')
  const horizontal = document.querySelector('.horizontal')
  if (spaceHolder) {
    spaceHolder.style.height = `${calcDynamicHeight(horizontal)}px`
  }

  window.addEventListener('scroll', () => {
    const sticky = document.querySelector('.sticky')
    if (horizontal && sticky) {
      horizontal.style.transform = `translateX(-${sticky.offsetTop}px)`
    }
  })

  window.addEventListener('resize', () => {
    if (spaceHolder) {
      spaceHolder.style.height = `${calcDynamicHeight(horizontal)}px`
    }
  })

  return (
    <section className="container">
      <div className="space-holder">
        <div className="sticky">
          <div className="horizontal">
            <section role="feed" className="cards">
              <div className={classes.leftContainer}>
                <div className={classes.assistant}>
                  <Text color='#344157' size='h2' weight='medium'>Real Success Stories with <Text color='secondary' size='h2' weight='medium'>Dataplayer</Text></Text>
                </div>
                <div>
                  <Button title="Explore Our Case Studies"
                    key='1'
                    id='buttonAiSection'
                    buttonType="primaryWhiteHome"
                    className={classes.learnMore}
                    onClick={() => history.push('/testimonials')}
                  >
                    <span><Arrow className={classes.arrow} style={{ marginLeft: 8 }} /></span>
                  </Button>
                </div>
              </div>
              {CASE_STUDIES.map((item) => (
                <CardHolder key={item.id} item={item} role="article" />
              ))}
            </section>
          </div>
        </div>
      </div>
    </section>
  )
}

const horizontalScrollerMobileStyles = makeStyles((theme) => ({
  mainWrapper: {
    display: 'flex',
    background: '#F8F8F8',
    width: '100%',
    alignItems: 'center',
    justifyContent: 'center',
  },
  leftContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
    minWidth: 300,
    [theme.breakpoints.down(600)]: {
      minWidth: 250,
    },
    [theme.breakpoints.down(430)]: {
      minWidth: 200,
    },
  },
  integrationText: {
    width: 'fit-content',
    border: '1px solid rgba(238, 67, 82, 0.97)',
    borderRadius: 24,
    paddingInline: 29,
    paddingBlock: 7,
    marginBottom: 16
  },
  colorText: {
    background: 'linear-gradient(90deg, #90205D 0%, rgba(238, 67, 82, 0.97) 100%)',
    backgroundClip: 'text',
    '-webkit-background-clip': 'text',
    '-webkit-text-fill-color': 'transparent',
  },
  assistant: {
    maxWidth: '60%',
    marginBottom: 10,
    [theme.breakpoints.down(600)]: {
      maxWidth: '70%',
    },
    [theme.breakpoints.down(430)]: {
      maxWidth: '90%',
    },
  },
  description: {
    maxWidth: '55%',
    marginBottom: 50,
    [theme.breakpoints.down(600)]: {
      maxWidth: '70%',
    },
    [theme.breakpoints.down(430)]: {
      maxWidth: '90%',
    },
  },
  learnMore: {
    maxWidth: 240
  },
  cardHolder: {
    display: 'flex',
    gap: 46,
    /* Adjust width based on content */
    width: '30%',
  }
}))

const HorizontalScrollerMobile = () => {
  const classes = horizontalScrollerMobileStyles()

  const spaceHolder = document.querySelector('.space-holder')
  const horizontal = document.querySelector('.horizontal')
  if (spaceHolder) {
    spaceHolder.style.height = `${calcDynamicHeight(horizontal)}px`
  }

  window.addEventListener('scroll', () => {
    const sticky = document.querySelector('.sticky')
    if (horizontal && sticky) {
      horizontal.style.transform = `translateX(-${sticky.offsetTop}px)`
    }
  })

  window.addEventListener('resize', () => {
    if (spaceHolder) {
      spaceHolder.style.height = `${calcDynamicHeight(horizontal)}px`
    }
  })



  return (
    <section className="container">
      <div className="space-holder">
        <div className="sticky">
          <div className="horizontal">
            <section role="feed" className="cards">
              <div className={classes.leftContainer}>
                <div className={classes.assistant}>
                  <Text color='#344157' size='h2' weight='medium'>Real Success Stories with <Text color='secondary' size='h2' weight='medium'>Dataplayer</Text></Text>
                </div>
                <div>
                  <Button title="Explore"
                    key='1'
                    id='buttonAiSection'
                    buttonType="primaryWhiteHome"
                    className={classes.learnMore}
                    onClick={() => window.open('/testimonials')}
                  >
                    <span><Arrow className={classes.arrow} style={{ marginLeft: 8 }} /></span>
                  </Button>
                </div>
              </div>
              {CASE_STUDIES.map((item) => (
                <CardHolder key={item.id} item={item} />
              ))}
            </section>
          </div>
        </div>
      </div>
    </section>
  )
}

const newsSectionStyles = makeStyles((theme) => ({
  mainWrapper: {
    display: 'flex',
    background: colors.white,
    width: '100%',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 65,
    paddingTop: 70,
    paddingBottom: 120,
    marginInline: 'auto',
    maxWidth: 1100,
    position: 'relative',
    [theme.breakpoints.up(1921)]: {
      maxWidth: 1300,
      justifyContent: 'space-between',
    },
    [theme.breakpoints.down(1440)]: {
      maxWidth: 1000,
      justifyContent: 'space-between',
    },
    [theme.breakpoints.down(1100)]: {
      maxWidth: 900,
      justifyContent: 'space-between',
    },
    [theme.breakpoints.down(960)]: {
      maxWidth: 700,
      justifyContent: 'space-between',
    },
    [theme.breakpoints.down(760)]: {
      maxWidth: '100%',
      flexDirection: 'column',
      gap: 42,
      paddingInline: 16,
      paddingBlock: 40,
    },
  },
  leftContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    width: '50%',
    [theme.breakpoints.down(760)]: {
      width: '100%',
    },
  },
  integrationText: {
    width: 'fit-content',
    border: '1px solid rgba(238, 67, 82, 0.97)',
    borderRadius: 24,
    paddingInline: 29,
    paddingBlock: 7,
    marginBottom: 16
  },
  colorText: {
    background: 'linear-gradient(90deg, #90205D 0%, rgba(238, 67, 82, 0.97) 100%)',
    backgroundClip: 'text',
    '-webkit-background-clip': 'text',
    '-webkit-text-fill-color': 'transparent',
  },
  assistant: {
    maxWidth: '60%',
    marginBottom: 24,
    [theme.breakpoints.down(1440)]: {
      maxWidth: '100%',
    },
    [theme.breakpoints.down(1250)]: {
      maxWidth: '70%',
    },
  },
  description: {
    maxWidth: '90%',
    marginBottom: 40
  },
  learnMore: {
    maxWidth: 240,
  },
  rightContainer: {
    display: 'flex',
    flex: 1,
    [theme.breakpoints.down(1100)]: {
      maxWidth: 450
    },
    [theme.breakpoints.down(960)]: {
      maxWidth: 350,
    },
    [theme.breakpoints.down(760)]: {
      maxWidth: '100%',
    },
  },
  circlesLeft: {
    position: 'absolute',
    top: '0%',
    left: '-20%',
    [theme.breakpoints.down(760)]:
    {
      display: 'none'
    }
  },
  circlesRight: {
    position: 'absolute',
    top: '25%',
    right: '-22%',
    [theme.breakpoints.down(760)]:
    {
      display: 'none'
    }
  }
}))

const NewsSection = () => {
  const classes = newsSectionStyles()
  const ref = useRef()
  const onScreen = useElementOnScreen(ref)
  const getStarted = (url) => {
    window.open(url, '_blank', 'noopener,noreferrer')
  }

  return (
    <section ref={ref} className={classes.mainWrapper} style={{
      opacity: onScreen ? 1 : 0,
      translate: onScreen ? 'none' : '0 50px',
      transition: '1s ease-in-out',
    }}>
      <Circles className={classes.circlesLeft} />
      <Circles className={classes.circlesRight} />
      <div className={classes.leftContainer}>
        <div className={classes.assistant}>
          <Text size='h2' weight='medium'>Latest Insights and Updates </Text>
        </div>
        <div className={classes.description}>
          <Text size='body'>Check out our newest article on the AI Assistant.
            Discover how this feature can transform data analytics with smarter insights and quicker decisions.
          </Text>
        </div>
        <div>
          <Button title="Visit blog"
            key='1'
            id='buttonAiSection'
            buttonType="primaryWhite"
            className={classes.learnMore}
            onClick={() => getStarted('https://blog.dataplayer.io/introducing-our-new-ai-assistant-feature-your-data-just-a-question-away/')}
          >
            <span><Arrow className={classes.arrow} style={{ marginLeft: 8 }} /></span>
          </Button>
        </div>
      </div>
      <div className={classes.rightContainer}>
        <Robot style={{ objectFit: 'cover', height: '100%' }} />
      </div>
    </section>
  )
}

const newsSectionStyles2 = makeStyles((theme) => ({
  mainWrapper: {
    display: 'flex',
    background: colors.white,
    width: '100%',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 65,
    paddingBlock: 70,
    marginInline: 'auto',
    maxWidth: 1100,
    position: 'relative',
    flexDirection: 'row-reverse',
    [theme.breakpoints.up(1921)]: {
      maxWidth: 1300,
      justifyContent: 'space-between',
    },
    [theme.breakpoints.down(1440)]: {
      maxWidth: 1000,
      justifyContent: 'space-between',
    },
    [theme.breakpoints.down(1100)]: {
      maxWidth: 900,
      justifyContent: 'space-between',
    },
    [theme.breakpoints.down(960)]: {
      maxWidth: 700,
      justifyContent: 'space-between',
    },
    [theme.breakpoints.down(760)]: {
      maxWidth: '100%',
      flexDirection: 'column',
      gap: 42,
      paddingInline: 16,
      paddingBlock: 40,
    },
  },
  leftContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    width: '50%',
    [theme.breakpoints.down(760)]: {
      width: '100%',
    },
  },
  integrationText: {
    width: 'fit-content',
    border: '1px solid rgba(238, 67, 82, 0.97)',
    borderRadius: 24,
    paddingInline: 29,
    paddingBlock: 7,
    marginBottom: 16
  },
  colorText: {
    background: 'linear-gradient(90deg, #90205D 0%, rgba(238, 67, 82, 0.97) 100%)',
    backgroundClip: 'text',
    '-webkit-background-clip': 'text',
    '-webkit-text-fill-color': 'transparent',
  },
  assistant: {
    maxWidth: '60%',
    marginBottom: 24,
    [theme.breakpoints.down(1440)]: {
      maxWidth: '100%'
    },
  },
  description: {
    maxWidth: '90%',
    marginBottom: 40
  },
  learnMore: {
    maxWidth: 240
  },
  rightContainer: {
    display: 'flex',
    flex: 1,
    [theme.breakpoints.down(1100)]: {
      maxWidth: 450
    },
    [theme.breakpoints.down(960)]: {
      maxWidth: 350,
    },
    [theme.breakpoints.down(760)]: {
      maxWidth: '100%',
    },
  },
  circlesLeft: {
    position: 'absolute',
    top: '25%',
    left: '-20%',
    [theme.breakpoints.down(760)]:
    {
      display: 'none'
    }
  },
  circlesRight: {
    position: 'absolute',
    top: '0%',
    right: '-22%',
    [theme.breakpoints.down(760)]:
    {
      display: 'none'
    }
  }
}))

const NewsSection2 = () => {
  const classes = newsSectionStyles2()
  const ref = useRef()
  const onScreen = useElementOnScreen(ref)
  const history = useHistory()
  const getStarted = (url) => {
    history.push(url)
  }
  return (
    <section ref={ref} className={classes.mainWrapper} style={{
      opacity: onScreen ? 1 : 0,
      translate: onScreen ? 'none' : '0 50px',
      transition: '1s ease-in-out',
    }}>
      <Circles className={classes.circlesLeft} />
      <Circles className={classes.circlesRight} />
      <div className={classes.leftContainer}>
        <div className={classes.assistant}>
          <Text size='h2' weight='medium'>Our Story</Text>
        </div>
        <div className={classes.description}>
          <Text size='body'>Founded by a leading tech company, Dataplayer blends cutting-edge technology with a passion for data solutions.
            Our mission is to empower healthcare practices with tools that turn complex data into actionable insights
          </Text>
        </div>
        <div>
          <Button title="Learn More"
            key='1'
            buttonType="primaryWhite"
            id='buttonAiSection'
            className={classes.learnMore}
            onClick={() => getStarted('/about')}
          >
            <span><Arrow style={{ marginLeft: 8 }} /></span>
          </Button>
        </div>
      </div>
      <div className={classes.rightContainer}>
        <Robot2 style={{ objectFit: 'cover', height: '100%' }} />
      </div>
    </section>
  )
}

function NewHome({ setSuccess, setSelectedArticleId }) {
  const [state, setState] = useState({
    mobileView: false,
  })

  const isMobile = window.innerWidth < 761
  const isMobileBigger = window.innerWidth < 961
  const isMobileSmall = window.innerWidth < 625

  useEffect(() => {
    const setResponsiveness = () => {
      return window.innerWidth < 961
        ? setState((prevState) => ({ ...prevState, mobileView: true }))
        : setState((prevState) => ({ ...prevState, mobileView: false }))
    }
    setResponsiveness()
    window.addEventListener('resize', () => setResponsiveness())
  }, [])

  return (
    <>
      <HeroHome />
      <LogosCarousel />
      <WhatDataplayerOffers isMobile={isMobileBigger} isMobileSmall={isMobileSmall} setSelectedArticleId={setSelectedArticleId} setSuccess={setSuccess} />
      {/* <FourthSection
        handleOnPriceCardClick={handleOnPriceCardClick}
        value={value}
        handleChangeHome={handleChangeHome}
        mobileView={state.mobileView}
        getStarted={getStarted}
      /> */}
      {/* <GraphSection /> */}
      <Integrations getStarted={getStarted} />
      {isMobile ? <HorizontalScrollerMobile /> : <HorizontalScroller />}
      <NewsSection />
      <NewsSection2 />
      {/* <GrayDivider /> */}
      {/* <div className={classes.divider}></div> */}
      {/* <FifthSection /> */}
      {/* <WallOfLove /> */}
    </>
  )
}

export default NewHome
